<template>
	<el-dialog title="" :visible.sync="createdVisible" width="578px" center :close-on-click-modal="false" @close="onResetForm('ruleForm')">
		<div slot="title" class="postion">
			<i class="iconfont icon-bianji1"></i>
			<span class="download">新增用户</span>
		</div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="top">
			<el-form-item label="用户名称" prop="displayName">
				<el-input v-model.trim="ruleForm.displayName" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item class="addressClass clearfix" label="业务权限" prop="regionCode">
				<el-cascader :options="options" :props="props" clearable v-model="ruleForm.regionCode" ref="bussniessCascader"></el-cascader>
			</el-form-item>
			<el-form-item class="w50 mr16" prop="principalName" label="负责人">
				<el-input v-model.trim="ruleForm.principalName" placeholder="姓名"></el-input>
			</el-form-item>
			<el-form-item class="w50 mr0" prop="phoneNumber">
				<el-input v-model.trim="ruleForm.phoneNumber" maxlength="11" placeholder="联系电话"></el-input>
			</el-form-item>
			<el-form-item prop="roles" label="数据权限" v-if="ruleForm.regionCode.length == 3">
				<el-checkbox-group v-model="ruleForm.roles">
					<el-checkbox label="view">数据查看</el-checkbox>
					<el-checkbox label="crud">功能操作</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="备注" prop="description">
				<el-input type="textarea" v-model.trim="ruleForm.description" autosize></el-input>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="onSave('ruleForm')">保存</el-button>
			<el-button @click="onResetForm('ruleForm')">取消</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { verifyPhone } from '@/utils/toolsValidate';
export default {
	data() {
		var checkPhone = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入联系方式'));
			} else if (!verifyPhone(value)) {
				callback(new Error('请输入正确的联系方式'));
			} else {
				callback();
			}
		};
		return {
			createdVisible: false,
			ruleForm: {
				displayName: '',
				accountLevel: '',
				regionCode: '',
				principalName: '',
				phoneNumber: '',
				roles: [],
				description: '',
			},
			rules: {
				displayName: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
				regionCode: [{ required: true, message: '请选择业务权限', trigger: 'change' }],
				principalName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
				phoneNumber: [{ required: true, validator: checkPhone, trigger: 'blur' }],
				roles: [{ required: true, message: '请选择数据权限', trigger: 'change' }],
				description: [{ required: true, message: '请输入', trigger: 'blur' }],
			},
			saveLoading: false,
			props: {
				value: 'code',
				label: 'title',
				children: 'children',
				checkStrictly: true,
				lazy: true,
				lazyLoad: (node, resolve) => {
					const { level, value } = node;
					this.getArea(level, value, resolve);
				},
			},
			options: [],
		};
	},
	components: {},
	methods: {
		init() {
			this.createdVisible = true;
			//新增
			this.ruleForm = this.$options.data().ruleForm; //清空表单
			this.$nextTick(() => {
				this.$refs.ruleForm.clearValidate();
			});
		},
		// 获取地区
		getArea(level, value, resolve) {
			let code = value ? value : null;
			this.$http
				.get(this.api.getChinaRegions, { params: { code } })
				.then((res) => {
					if (res.data && res.data.success) {
						let nodes = res.data.collection || [];
						if (!value && level == 0) {
							nodes.unshift({
								code: '0',
								title: '全国',
								children: null,
								leaf: false,
							});
						}
						if (level == 4) {
							nodes.forEach((item) => {
								// 当点击最后一级的时候 label 后面不会转圈圈 并把相关值赋值到选择器上
								item.leaf = level >= 1;
							});
						}
						//通过调用resolve将子节点数据返回，通知组件数据加载完成
						resolve(nodes);
					}
				})
				.catch((e) => {});
		},
		// 保存
		async onSave(formName) {
			this.$refs[formName].validate(async (valid) => {
				if (valid) {
					let checkNodes = this.$refs['bussniessCascader'].getCheckedNodes();
					if (!checkNodes || checkNodes.length == 0) return this.$message.error('地址信息获取失败，请重试');
					this.saveLoading = true;
					const { pathLabels, value } = checkNodes[0];
					let address = pathLabels?.length > 0 ? (pathLabels.length > 3 ? pathLabels[0] + pathLabels[1] + pathLabels[2] : pathLabels.join('')) : '';
					let parObj = {
						address,
						key: '523b089c990b13846be5d10eb9bb8bf0',
					};
					let res = await $.ajax({
						url: 'https://restapi.amap.com/v3/geocode/geo',
						type: 'get',
						dataType: 'jsonp',
						data: parObj,
						success: function (data) {
							return data.geocodes[0];
						},
					});
					let par = {
						...this.ruleForm,
						regionCode: value,
						longitude: res.geocodes[0].location.split(',')[0],
						latitude: res.geocodes[0].location.split(',')[1],
						roles: value.length == 6 ? this.ruleForm.roles : ['view'],
					};

					this.$http
						.post(this.api.getRegionManagementGroups + '.json', par)
						.then((res) => {
							if (res.data && res.data.success) {
								this.$message.success('添加成功');
								this.$emit('getList');
								this.saveLoading = false;
								this.onResetForm(formName);
							}
						})
						.catch((e) => {
							this.saveLoading = false;
						});
				}
			});
		},
		onResetForm(formName) {
			this.createdVisible = false;
			this.$refs[formName].resetFields();
		},
	},
};
</script>

<style lang="scss" scoped>
.postion {
	font-size: 18px;
	.icon-bianji1 {
		margin-right: 16px;
		color: #1db9b1;
	}
}
/deep/ .el-form {
	padding-bottom: 20px;
	> div {
		margin-bottom: 20px !important;
		.el-form-item__label {
			line-height: 14px;
			height: 14px;
			margin-bottom: 8px;
		}
	}
	.el-cascader,
	.el-input,
	.el-select {
		width: 100%;
	}
	.dateClass {
		.el-range-editor {
			width: 100%;
		}
		.el-range-input {
			width: 45%;
		}
		.el-range-separator {
			display: inline-block;
			line-height: 32px;
			height: 32px;
		}
	}
}
.addressClass {
	&-content {
		width: calc((100% - 32px) / 5);
		margin-right: 8px;
		margin-bottom: 0;
	}
}
/deep/ .mr0 {
	margin-right: 0 !important;
}
/deep/ .el-button {
	margin-left: 16px;
}
/deep/ .el-dialog__footer {
	padding-top: 0px !important;
}
/deep/ .w50 {
	width: calc(50% - 8px);
	display: inline-block;
}
/deep/ .el-textarea__inner {
	min-height: 64px !important;
	line-height: 18px !important;
	padding: 5px 12px !important;
}
</style>